<!-- <layout-block-list-outlet [attr.aria-label]="page?.layoutLabel"
                          [list]="page?.prelayout"></layout-block-list-outlet> -->
<!-- Breadcrumb skal ligge som et dynamisk element -->
<!-- Creation date er udkommenteret - da det ikke er med i designet -->
<!-- <div>
    <span class="meta">{{ 'ARTICLE_PAGE.CREATED' | translate: {date:(page._meta.created | date:'dd/MM YYYY') } }} | {{ 'ARTICLE_PAGE.UPDATED' | translate: {date:(page._meta.updated | date:'dd/MM YYYY') } }}</span>
</div> -->
<layout-block-list-outlet [attr.aria-label]="page?.layoutLabel"
                          [list]="page?.layout"></layout-block-list-outlet>
